import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProofSection() {
  const testimonials = [{
    name: 'María Laura G.',
    text: 'Literalmente me salvó la vida. Trabajo todo el día y llegaba a la noche a comer galletitas. Ahora dejo todo preparado y como riquísimo. Me desinflamé un montón en solo dos semanas.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop'
  }, {
    name: 'Sofía M.',
    text: 'Pensé que iba a ser difícil conseguir los ingredientes, pero no. Todo se compra en el súper o la dietética del barrio. Las recetas son súper fáciles.',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1974&auto=format&fit=crop'
  }, {
    name: 'Carolina T.',
    text: 'Los postres son una locura. No puedo creer que no tengan azúcar. Mi marido y mis hijos los comen y ni se dan cuenta que son saludables jajaja.',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=1964&auto=format&fit=crop'
  }, {
    name: 'Julieta R.',
    text: 'Lo que más me sirvió fue el bonus de meal prep. Cocino el domingo a la tarde y me olvido toda la semana. Un viaje de ida.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1961&auto=format&fit=crop'
  }, {
    name: 'Agustina P.',
    text: 'Bajé la ansiedad un montón. Antes picoteaba todo el día, ahora con estas comidas me siento llena de verdad y con energía.',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1976&auto=format&fit=crop'
  }, {
    name: 'Valentina L.',
    text: 'Vale cada centavo. Gastaba más plata pidiendo delivery porque no sabía qué cocinar. Ahora como mejor, más rico y ahorro plata.',
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=1964&auto=format&fit=crop'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-149">
      <div className="max-w-6xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-151">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal mb-4" data-id="element-152">
            💥{' '}
            <span className="font-extrabold bg-yellow-200/60 px-2 rounded" data-id="element-153">
              +10,000 personas
            </span>{' '}
            ya dejaron de improvisar sus comidas
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-154">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-background p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 flex flex-col h-full" data-id="element-155">
              <div className="flex items-center space-x-1 text-bonus mb-4" data-id="element-156">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-157" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-158">
                "{testimonial.text}"
              </p>
              <div className="flex items-center space-x-4 mt-auto" data-id="element-159">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-160" />
                <span className="font-bold text-charcoal" data-id="element-161">
                  {testimonial.name}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}